module.exports = __webpack_public_path__ + "./images/5cc09c3d7fc24ca7d8524d0756f6ea3e.webp";